import _extends from "@babel/runtime/helpers/extends";
import { Box, Text, Tooltip } from '@wix/design-system';
import React from 'react';
import { ECLIPSE_SALE_BG_COLOR } from '../../utils/consts';
import s from './CycleSelectorBadge.scss';
export const CycleSelectorBadgeUi = _ref => {
  let {
    dataHook,
    tooltipDataHook,
    skin = 'default',
    text,
    tooltipContent,
    onShowTooltip,
    isMobile = false,
    uppercase = true,
    ...boxProps
  } = _ref;
  if (!text) {
    return null;
  }
  const handleShowTooltip = () => {
    onShowTooltip == null || onShowTooltip(tooltipContent);
  };
  return /*#__PURE__*/React.createElement(Tooltip, {
    dataHook: tooltipDataHook,
    content: tooltipContent,
    disabled: !tooltipContent,
    onShow: handleShowTooltip
  }, /*#__PURE__*/React.createElement(Box, _extends({
    dataHook: dataHook,
    align: "center",
    padding: isMobile ? '0 8px' : '3px 10px',
    boxSizing: "border-box",
    borderRadius: "4px",
    height: "24px",
    backgroundColor: ECLIPSE_SALE_BG_COLOR,
    verticalAlign: "middle"
  }, boxProps), /*#__PURE__*/React.createElement(Text, {
    className: `${s.text}${uppercase ? ` ${s.uppercase}` : ''}`
  }, text)));
};
//# sourceMappingURL=CycleSelectorBadgeUi.js.map